<template>
  <div
    data-testid="page-footer"
    class="my-8 md:px-3 overflow-hidden max-w-screen-xl mx-auto"
  >
    <div
      class="grid grid-cols-1 md:grid-cols-4 xl:grid-cols-5 gap-y-0 md:gap-y-8 md:gap-x-8"
    >
      <!-- Column 1: GPORTAL Info -->
      <div
        class="xl:row-span-2 md:col-span-4 xl:col-span-1 text-center xl:text-left py-6 md:py-0 max-md:px-3"
      >
        <router-link
          class="inline-block"
          :to="`/${locale}`"
          :aria-label="$t('general/menu/back-to-home')"
        >
          <common-gportal-logo />
        </router-link>

        <p class="mt-4 mb-0 font-bold text-rhino leading-7">
          EU: Ociris GmbH
          <span class="inline md:hidden px-1 opacity-25">|</span>
          <br class="hidden md:inline" />
          Welfenstraße 22
          <span class="inline md:hidden px-1 opacity-25">|</span>
          <br class="hidden md:inline" />
          81541 München
        </p>

        <p class="mt-4 mb-0 font-bold text-rhino leading-7">
          US: GPORTAL, Inc
          <span class="inline md:hidden px-1 opacity-25">|</span>
          <br class="hidden md:inline" />
          3416 Hillcrest Dr
          <span class="inline md:hidden px-1 opacity-25">|</span>
          <br class="hidden md:inline" />
          Waco, TX 76708
        </p>
      </div>

      <!-- Row 1: Link Groups & Locale Switcher -->
      <footer-link-group
        class="border-t border-rhino/25 md:border-0"
        :title="$t('frontend/popular-games')"
        :links="popularGamesLinks"
      />
      <footer-link-group
        class="border-t border-rhino/25 md:border-0"
        :title="$t('general/menu/block/account')"
        :links="profileLinks"
      />
      <footer-link-group
        class="border-t border-rhino/25 md:border-0"
        :title="'GPORTAL'"
        :links="gportalLinks"
      />
      <footer-locale-switcher
        class="py-4 md:py-0 border-t border-rhino/25 md:border-0 max-md:px-3"
      />

      <!-- Row 2 items -->
      <footer-support-info class="xl:col-start-2 py-4 md:py-0 max-md:px-3" />
      <footer-social-media class="xl:col-start-3 py-4 md:py-0 max-md:px-3" />
      <footer-payment-options
        class="xl:col-start-4 md:col-span-2 py-4 md:py-0 max-md:px-3"
      />
    </div>
    <p class="mt-8 text-rhino max-md:px-3">
      {{ $t('footer/footer/terms') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useFooterLinks } from './features';

const { locale } = useI18n();
const { popularGamesLinks, profileLinks, gportalLinks } = useFooterLinks();
</script>

<style scoped></style>
